"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../../utils/constants");
var muiPlayCircleFill16 = {
    paths: [
        {
            path: 'M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M6.14364101,5.12515761 C6.04350507,5.21315208 5.99587796,5.32870913 6.0002792,5.44270915 L6.0009842,5.52481666 C6.00383319,6.18079582 6.00073512,10.469942 6.00121839,10.5725413 C6.00173151,10.681475 6.04899543,10.7906056 6.14364101,10.8737754 C6.33512161,11.042039 6.64129182,11.0415824 6.8304524,10.8753575 L10.5048945,8.54083275 C10.9750256,8.24213907 10.9702844,7.75475767 10.5048945,7.45896657 L6.8304524,5.12357558 C6.64320312,4.95903024 6.33379588,4.95805898 6.14364101,5.12515761 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Play',
    width: 16,
    height: 16,
};
var muiPlayCircleFill = {
    base: muiPlayCircleFill16,
    smIcon: muiPlayCircleFill16,
};
exports.muiPlayCircleFill = muiPlayCircleFill;
//# sourceMappingURL=playCircleFill.js.map